import { driverCapacitor } from './capacitor.js';
import { abrirBanco, conexaoAtual, fecharBanco } from './connection.js';

export { conexaoAtual, fecharBanco };
export { NOME_BANCO, SCHEMA_VERSION } from './schema.js';

export function initDatabase() {
    return abrirBanco({ driver: driverCapacitor });
}
